export const osLatlngParser = (position) => {
  return position?.lat && position?.lng ? [position.lat, position.lng] : position;
};
